<h2 mat-dialog-title>
  @if (data?.scheduleDeactivationDate) {
    {{ 'MANAGE_ACCOUNTS.DEACTIVATE_DEPENDENT_PRODUCT_DIALOG.TITLE_SCHEDULE_DEACTIVATIONS' | translate }}
  } @else {
    {{ 'MANAGE_ACCOUNTS.DEACTIVATE_DEPENDENT_PRODUCT_DIALOG.TITLE' | translate }}
  }
</h2>

<mat-dialog-content class="alert-container">
  <div class="dialog-content">
    @if (!data?.scheduleDeactivationDate) {
      <div>
        {{
        'MANAGE_ACCOUNTS.DEACTIVATE_DEPENDENT_PRODUCT_DIALOG.REQUIRED_PRODUCT_TEXT'
        | translate
        : {
        productName: data?.requiredProduct?.name,
      }
      }}
    </div>
  }
  @if (data?.scheduleDeactivationDate) {
    <div>
      {{
      'MANAGE_ACCOUNTS.DEACTIVATE_DEPENDENT_PRODUCT_DIALOG.REQUIRED_PRODUCT_TEXT_SCHEDULE_DEACTIVATIONS'
      | translate
      : {
      productName: data?.requiredProduct?.name,
      scheduleDeactivationDate: data?.scheduleDeactivationDate | date: 'mediumDate',
    }
    }}
  </div>
}

<div class="dependent-products-container">
  @for (dependentProduct of data?.dependentProducts; track dependentProduct) {
    <div class="dependent-product">
      <va-icon
        [diameter]="32"
        [iconName]="dependentProduct?.name || dependentProduct?.title"
        [iconUrl]="dependentProduct?.icon_url || dependentProduct?.icon"
        class="icon"
      ></va-icon>
      <div class="label">
        <span>{{ dependentProduct?.name || dependentProduct?.title }}</span>
        @if (
          data?.dependentProductsToNumberOfActivations?.get(
          dependentProduct?.product_id || dependentProduct?.addonId
          ) > 1
          ) {
          <span
            >
            ({{
            data?.dependentProductsToNumberOfActivations?.get(
            dependentProduct?.product_id || dependentProduct?.addonId
            )
            }})
          </span>
        }
      </div>
    </div>
  }
</div>
@if (!data?.scheduleDeactivationDate) {
  <div>
    {{
    'MANAGE_ACCOUNTS.DEACTIVATE_DEPENDENT_PRODUCT_DIALOG.ACTION_DESCRIPTION'
    | translate
    : {
    productName: data?.requiredProduct?.name,
  }
  }}
</div>
}
</div>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" color="primary" mat-button matDialogClose>
    {{ 'MANAGE_ACCOUNTS.DEACTIVATE_DEPENDENT_PRODUCT_DIALOG.KEEP_PRODUCT' | translate }}
  </button>
  <button mat-raised-button color="warn" (click)="continueDeactivate()">
    {{ 'COMMON.ACTION_LABELS.CONFIRM' | translate }}
  </button>
</mat-dialog-actions>
